export const style = {
  cbg: {
    background: `#2a2a2a`,
    padding: `20px 25px`
  },
  cfont: {
    color: `white`
  },
  sbg: {
    background: `#2B2B2B`,
    borderRight: `1px solid #353535`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Settings/Motd/style/gui.js